import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconNoiseSuppressionOn } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { FREQUENCY_FILTER_SLIDER_MAXIMUM, FREQUENCY_FILTER_SLIDER_MINIMUM } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const FrequencyFilterSlider = ({ initialValue, onChange, label }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [frequencySetting, setFrequencySetting] = useState(initialValue);
    const _onFrequencyAdjustChange = useCallback((event) => {
        const newFrequencySetting = Math.floor(Number(event.currentTarget.value));
        onChange(newFrequencySetting);
        setFrequencySetting(newFrequencySetting);
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('frequencyFilterSlider'), className: cx('popupmenu__contents', classes.contextMenuSlider) },
        React.createElement("label", { className: classes.contextMenuSliderLabel }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconNoiseSuppressionOn })),
            React.createElement("input", { "aria-valuemax": FREQUENCY_FILTER_SLIDER_MAXIMUM, "aria-valuemin": FREQUENCY_FILTER_SLIDER_MINIMUM, "aria-valuenow": frequencySetting, max: FREQUENCY_FILTER_SLIDER_MAXIMUM, min: FREQUENCY_FILTER_SLIDER_MINIMUM, onChange: _onFrequencyAdjustChange, tabIndex: 0, type: 'range', value: frequencySetting }))));
};
export default FrequencyFilterSlider;
